export default [
  {
    path: "/raporkarne",
    name: "raporkarne",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "raporkarne.Baslik",
      yetki: { k: [2000802] },
    },
  },
]
